/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MarkerParticipantOut } from './markerParticipantOut';

export interface MarkerSpanOut {
  kind: 'screen_share';
  start_ms: number;
  end_ms: number;
  participant: MarkerParticipantOut | null;
}
